<template>
  <div class="header-public">
    <img alt="logo" width="295" src="../../assets/logo_white.svg" />
    <div class="float-right actions-receiver">
      <div class="change-locale">
        <router-link :to="{ query: { locale: 'en' } }" :class="{ active: locale === 'en' }">En</router-link> |
        <router-link :to="{ query: { locale: 'de' } }" :class="{ active: locale === 'de' }">De</router-link>
      </div>
      <a :href='testiomonialsUrl' target="_blank">{{ $t('record_show_public.testimonials') }}</a>
      <a href="https://calendly.com/christian-alsen" class="btn btn-white" target="_blank">{{ $t('record_show_public.schedule_demo') }}</a>
      <a :href='registrationUrl' class="btn btn-mustard" target="_blank">{{ $t('record_show_public.sign_up_free') }}</a>
    </div>
    <h1 class="finanz">
      {{ $t('record_show_public.header') }}
    </h1>
  </div>
</template>

<script>
  export default {
    computed: {
      testiomonialsUrl() {
        return `https://www.relatico.com/testimonials?lang=${this.locale}`
      },
      registrationUrl() {
        return `https://app.relatico.com/register?lang=${this.locale}`
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../../styles/header"
</style>
